/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Enlarge CBB images
 * 
 * @returns {Void}
 */
const enlargeCBBImages = () => {
  const images = document.querySelectorAll('.cbb-frequently-bought-product-image');
  if (!images.length) {
    setTimeout(enlargeCBBImages, 100);
    return;
  }
  
  images.forEach((image) => {
    const src = image.style.backgroundImage.replace('url("', '').replace('")', '').replace('120x120', '500x');
    image.style.backgroundImage = `url("${src}")`;
  });
}

const addInputEvents = () => {
  const inputs = document.querySelectorAll('.cbb-frequently-bought-selector-input');
  if (!inputs.length) {
    setTimeout(addInputEvents, 100);
  }

  inputs.forEach((input, index) => {
    input.addEventListener('change', (e) => {
      const product = document.querySelector(`.cbb-frequently-bought-product:nth-child(${index})`);
      if (!product) {
        return;
      }
      product.classList.toggle('is-selected');
    });
  })
}

const fixCLS = () => {
  const widgetContainer = document.querySelector('.cm_vehicle-widget__header-container');
  const headerElement = document.querySelector('#cm_Garage');

  if(!widgetContainer || !headerElement) {
    setTimeout(fixCLS, 100);
    return;
  }

  setTimeout(() => {
    widgetContainer.classList.add('is-loaded');
    headerElement.classList.add('is-loaded');
  }, 1000)
}

window.addEventListener("DOMContentLoaded", () => {
  enlargeCBBImages();
  addInputEvents();
  fixCLS();
});